import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=e2b4b6c8&scoped=true&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"
import style1 from "./PieChart.vue?vue&type=style&index=1&id=e2b4b6c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b4b6c8",
  null
  
)

export default component.exports